export const DYNAMIC_CALCULATION_DATA_FIELD_KEY_PREFIX = 'dynamic_calculation__' as const;
export const DYNAMIC_CALCULATION_DATA_FIELD_KEY_REGEX = new RegExp(
  String.raw`^${DYNAMIC_CALCULATION_DATA_FIELD_KEY_PREFIX}`
);
